<div class="change-password-container">
  <div class="change-password-card">
    <div class="header">
      <h1>Change Password</h1>
      <p class="subtitle">Update your account password</p>
    </div>

    <!-- Success/Error Messages -->
    <div *ngIf="successMessage" class="alert alert-success">
      {{ successMessage }}
    </div>
    <div *ngIf="errorMessage" class="alert alert-error">
      {{ errorMessage }}
    </div>

    <form (ngSubmit)="onSubmit()" class="password-form">
      <div class="form-group">
        <label for="current_password">Current Password</label>
        <div class="password-input-wrapper">
          <input 
            [type]="showPassword.current ? 'text' : 'password'" 
            id="current_password" 
            [(ngModel)]="passwordForm.current_password" 
            name="current_password" 
            required
            placeholder="Enter your current password"
            class="form-control">
          <button 
            type="button" 
            class="toggle-password-btn" 
            (click)="togglePasswordVisibility('current')"
            tabindex="-1">
            <span *ngIf="!showPassword.current">👁️</span>
            <span *ngIf="showPassword.current">🙈</span>
          </button>
        </div>
      </div>

      <div class="form-group">
        <label for="new_password">New Password</label>
        <div class="password-input-wrapper">
          <input 
            [type]="showPassword.new ? 'text' : 'password'" 
            id="new_password" 
            [(ngModel)]="passwordForm.new_password" 
            name="new_password" 
            required
            placeholder="Enter your new password"
            class="form-control">
          <button 
            type="button" 
            class="toggle-password-btn" 
            (click)="togglePasswordVisibility('new')"
            tabindex="-1">
            <span *ngIf="!showPassword.new">👁️</span>
            <span *ngIf="showPassword.new">🙈</span>
          </button>
        </div>
        <small class="form-hint">
          Password must be at least 8 characters and contain uppercase, lowercase, and a digit
        </small>
      </div>

      <div class="form-group">
        <label for="confirm_password">Confirm New Password</label>
        <div class="password-input-wrapper">
          <input 
            [type]="showPassword.confirm ? 'text' : 'password'" 
            id="confirm_password" 
            [(ngModel)]="confirmPassword" 
            name="confirm_password" 
            required
            placeholder="Confirm your new password"
            class="form-control">
          <button 
            type="button" 
            class="toggle-password-btn" 
            (click)="togglePasswordVisibility('confirm')"
            tabindex="-1">
            <span *ngIf="!showPassword.confirm">👁️</span>
            <span *ngIf="showPassword.confirm">🙈</span>
          </button>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="loading">
          {{ loading ? 'Changing Password...' : 'Change Password' }}
        </button>
      </div>
    </form>
  </div>
</div>
